import React from 'react'
import {FaEye, FaFileSignature, FaPaperclip} from "react-icons/fa"
import userService from "../../../../services/web/user-service.js";
import InputForm from "../../../../components/input/input-form.jsx";
import InputTextarea from "../../../../components/input/input-textarea.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import InputRadio from "../../../../components/input/input-radio.jsx";
import Button from "../../../../components/button/button.jsx";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {getAssetPath} from "../../../../utils/get-asset-path.js";

const MySwal = withReactContent(Swal);
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const FormRender = ({structure, state, setState, openModalAttach}) => {

    const onChangeInput = ({target: {id, value}}) => setState(prev => ({...prev, [id]: value}))

    const handleDate = (value, item, type) => {
        setState(prev => ({...prev, [item]: type === "date" && value ? new Date(value).toISOString().split("T")[0] : value}))
    }

    const onChangeRadio = (checked, option, id) => {
        let value = null
        if (checked) value = [option]

        setState(prev => ({...prev, [id]: value}))
    }

    const onChangeCheckbox = (checked, option, id) => {
        setState(prev => {
            const currentValues = prev[id] || []

            let updatedValues
            if (checked) updatedValues = [...currentValues, option]
            else updatedValues = currentValues.filter(o => o !== option)

            return {...prev, [id]: updatedValues}
        })
    }

    const onChangeInTextInput = (id, index, value) => {
        setState(prev => {
            const current = prev[id] || []
            const updated = [...current]
            updated[index] = value

            return {...prev, [id]: updated}
        })
    }

    const onClickAttachBtn = (e, id) => {
        e.preventDefault()

        const input = document.createElement('input')
        input.type = 'file'
        input.accept = 'image/png, image/jpeg'
        input.onchange = event => {
            const file = event.target.files[0]
            if (file.size > 2000000) {
                // projectUtils.swalErrorMessage("", "Tamanho máximo de arquivo excedido. Limite: 2MB", "Ok")
                return
            }

            file.targetId = id
            file.url = URL.createObjectURL(file)
            setState(prev => ({...prev, [id]: file}))
        }

        input.click()
    }

    const onClickAgentSignatureBtn = (e, id) => {
        e.preventDefault()

        userService.getSignatureDefault()
            .then((data) => {
                if (!data) {
                    projectUtils.swalErrorMessage("", "Usuário não possui assinatura cadastrada.", "Ok")
                    return
                }

                MySwal.fire({
                    title: "Confirmar assinatura?",
                    imageUrl: API_KEEPER + "/ged/attach/" + data.id,
                    showCancelButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                    cancelButtonColor: '#e64942',
                    confirmButtonColor: '#063A6C',
                    reverseButtons: true
                })
                .then(({isConfirmed}) => {
                    if (!isConfirmed) return;

                    data.attachId = data.id
                    data.targetId = id
                    setState(prev => ({...prev, [id]: data}))
                });
            })
            .catch((error) => {
                console.error(error)
                projectUtils.swalErrorMessage("", "Não foi possível obter a assinatura do agente.")
            })
    }

    const input = (item) => {
        return (
            <InputForm
                id={item.id}
                label={item.label + (item.required ? " *" : "")}
                type={"text"}
                value={state[item.id] || ""}
                readOnly={!!item?.readOnly}
                required={item.required}
                onChange={onChangeInput}
            />
        )
    }

    const date = (item) => {
        return (
            <InputDateTime
                id={item.id}
                label={item.label + (item.required ? " *" : "")}
                dateFormat="L"
                selected={state[item.id]}
                onChange={(date) => handleDate(date, item.id, item.type)}
            />
        )
    }

    const dateTime = (item) => {
        return (
            <InputDateTime
                id={item.id}
                label={item.label + (item.required ? " *" : "")}
                dateFormat="LL"
                selected={state[item.id]}
                onChange={(date) => handleDate(date, item.id, item.type)}
            />
        )
    }

    const textArea = (item) => {
        return (
            <>
                <span className={"text-[14px]"}>{item.label + (item.required ? " *" : "")}</span>
                <InputTextarea
                    id={item.id}
                    label={""}
                    onChange={onChangeInput}
                    value={state[item.id] || ""}
                    textAreaClass={"h-[100px]"}
                    readOnly={!!item?.readOnly}
                />
            </>
        )
    }

    const checkbox = (item) => {
        return (
            <>
                <h4 className="text-[14px]" required={item.required}>{item.label} {item.required ? "*" : ""}</h4>
                {
                    item.options.map((option, index) => (
                        <InputCheckbox
                            key={"checked-" + index + "-" + item.id}
                            id={"option-" + index + "-" + item.id}
                            name={"option-" + index + "-" + item.id}
                            label={option}
                            checked={state[item.id]?.includes(option) ?? false}
                            onChange={({target: {checked}}) => onChangeCheckbox(checked, option, item.id)}
                        />
                    ))
                }
            </>
        )
    }

    const radio = (item) => {
        return (
            <>
                <h4 className="text-[14px]">{item.label} {item.required ? "*" : ""}</h4>
                {
                    item.options.map((option, index) => (
                        <InputRadio
                            key={"radio-" + index + "-" + item.id}
                            id={"option-" + index + "-" + item.id}
                            name={"option-" + item.id}
                            label={option}
                            required={item.required}
                            checked={state[item.id]?.includes(option) ?? false}
                            onChange={({target: {checked}}) => onChangeRadio(checked, option, item.id)}
                        />
                    ))
                }
            </>
        )
    }

    const inText = (item) => {
        const split = item.label.split(":input")

        const input = (index) => (
            <input
                id={item.id + "-" + index}
                className="other-input"
                placeholder={"Digite aqui"}
                type="text"
                value={state[item.id]?.[index] || ""}
                onChange={(e) => onChangeInTextInput(item.id, index, e.target.value)}
            />
        )

        return split.map((text, index) =>
            (
                <React.Fragment key={item.id + "-" + index}>
                    {text}
                    {index < split.length - 1 && input(index)}
                </React.Fragment>
            )
        )
    }

    const file = ({id, label}) => {
        const file = state[id] || null

        return (
            <>
                {
                    !file &&
                    <Button className="focus:ring-blue-300 w-full" onClick={(e) => onClickAttachBtn(e, id)}>
                        <FaPaperclip /> {label}
                    </Button>
                }

                {
                    file &&
                    <Button className="!text-white !bg-[#1588F3] hover:!bg-[#a7d4ff] w-full" onClick={(e) => openModalAttach(e, file, id)}>
                        <FaEye /> Visualizar anexo
                    </Button>
                }
            </>
        )
    }

    const signature = ({label}) => {
        return (
            <div className="w-full mt-3">
                <p className="line-leader-signature text-[13px]" style={{textAlign: "center", justifySelf: "right"}}>
                    {label}
                </p>
            </div>
        )
    }

    const agentSignature = ({id}) => {
        const file = state[id] || null

        return (
            <>
                {
                    !file &&
                    <Button className="focus:ring-blue-300 w-full" onClick={(e) => onClickAgentSignatureBtn(e, id)}>
                        <FaFileSignature /> Incluir assinatura do agente
                    </Button>
                }

                {
                    file &&
                    <Button className="!text-white bg-[#1588F3] hover:bg-[#a7d4ff] w-full" onClick={(e) => openModalAttach(e, file, id)}>
                        <FaEye /> Visualizar assinatura
                    </Button>
                }
            </>
        )
    }

    const image = (item) => {
        let url = getAssetPath("img/no-img.png");
        if (item?.file) url = item.file?.url;
        else if (item?.gedId) url = API_KEEPER + "/ged/attach/" + item.gedId;

        return (
            <img
                src={url}
                alt=""
                className={"max-h-200 max-w-full justify-self-center"}
            />
        )
    }

    const handleStructure = (item) => {
        if (!item) return null

        const { type, id, label } = item

        const components = {
            input: () => input(item),
            textarea: () => textArea(item),
            radio: () => radio(item),
            checkbox: () => checkbox(item),
            date: () => date(item),
            datetime: () => dateTime(item),
            title: () => <h2 className="text-center text-[24px] font-bold m-0 whitespace-break-spaces">{label}</h2>,
            subtitle: () => <h3 className="mb-0 font-bold whitespace-break-spaces border-b border-b-[#bdbdbd]">{label}</h3>,
            intext: () => inText(item),
            file: () => file(item),
            signature: () => signature(item),
            agentSignature: () => agentSignature(item),
            image: () => image(item),
        }

        const Element = components[type]
        if (!Element) return null

        return <div key={id} className={"text-[14px]"}>{Element()}</div>
    }

    return structure?.map(handleStructure)
}

export default FormRender